/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_No_DescriptionInputs */

const en_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No description provided.`)
};

const de_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Beschreibung vorhanden.`)
};

const fr_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune description fournie.`)
};

const es_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin descripción proporcionada.`)
};

const it_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna descrizione fornita.`)
};

const nl_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen beschrijving beschikbaar.`)
};

const pl_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak opisu.`)
};

const fi_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvausta ei ole.`)
};

const da_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen beskrivelse.`)
};

const sv_jobs_no_description = /** @type {(inputs: Jobs_No_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen beskrivning angiven.`)
};

/**
* | output |
* | --- |
* | "No description provided." |
*
* @param {Jobs_No_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_no_description = /** @type {((inputs?: Jobs_No_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_No_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_no_description(inputs)
	if (locale === "fr") return fr_jobs_no_description(inputs)
	if (locale === "es") return es_jobs_no_description(inputs)
	if (locale === "it") return it_jobs_no_description(inputs)
	if (locale === "nl") return nl_jobs_no_description(inputs)
	if (locale === "pl") return pl_jobs_no_description(inputs)
	if (locale === "fi") return fi_jobs_no_description(inputs)
	if (locale === "da") return da_jobs_no_description(inputs)
	if (locale === "sv") return sv_jobs_no_description(inputs)
	return en_jobs_no_description(inputs)
});